export default "__VITE_ASSET__32oVwuvx__"